import styled from 'styled-components';

export const Title = styled.div`
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  color: #00BFA5;
  margin: 0 0 8px 0;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 360px;
  width: 100%;
  
  & > span {
    color: #323232;
  }
`;

export const Description = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color:  #323232;
  margin: 0 0 24px;
  text-align: center;
  max-width: 330px;
`;

export const StyledList = styled.ul`
  width: 100%;
  padding: 0;
  margin: 35px 0 24px 0;
  list-style: none;
  max-width: 330px;
`;
export const StyledLi = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${({ active }) =>
        active ? 'linear-gradient(92.01deg, #00BFA5 0%, #007F90 100%)' : '#ffffff'};
  border: ${({ active }) =>
        active
            ? '1px solid #ffffff'
            : '1px solid #D4D4D4'};
  color: ${({ active }) =>
        active ? '#ffffff' : '#909090'};
  border-radius: 16px;
  width: 100%;
  min-height: 74px;
  padding: 7px 0;
  position: relative;
  cursor: pointer;
  &:focus {
    outline: none;
  }

  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const StyledPeriod = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    min-width: 20px;
    border-radius: 50%;
    margin-right: 14px;
    margin-left: 14px;
  }
  span {
    font-weight: ${({ active }) => active ? 600 : 400};
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }
`;

export const StyledPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 7px;
  align-self: stretch;
  justify-content: center;
  padding: 8px 14px;
  background-color: #ffffff;
  color: ${({ active }) =>
        active ? '#018191' : '#919191'};
  border-radius: 12px;

  ${({ withLabel }) =>
        withLabel &&
        `&:not(:last-child) {
          margin-top: 13px;
        }`}
`;

export const StyledOldValue = styled.span`
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #8DD1C8;
  text-decoration: line-through;
`;

export const StyledValue = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.2px;
`;

export const StyledPerWeek = styled.span`
  font-weight: 600;
  font-size: 8px;
  line-height: 10px;
`;

export const BestLabel = styled.div`
  position: absolute;
  top: 0;
  left: ${({isDiscount}) => isDiscount ? '32%' : '12px'};
  background-color: #ffffff;
  border-radius: 7px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #018191;
  text-transform: uppercase;
  transform: translateY(-50%);
  box-shadow: 0px 4px 11px rgba(0, 0, 0, 0.25);
  padding: 5px 16px;
  border: 1px solid #018191;
`;

export const SaveAmount = styled.div`
  position: absolute;
  top: 0;
  right: 5px;
  background-color: #ffffff;
  border-radius: 7px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #018191;
  text-transform: uppercase;
  transform: translateY(-50%);
  box-shadow: 0px 4px 11px rgba(0, 0, 0, 0.25);
  padding: 5px 6px;
  border: 1px solid #018191;
`;